"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RepeatMonthlyOnEnum = exports.RepeatEndsOnEnum = exports.BookingRepeatIntervalEnum = exports.BookingRepeatEnum = exports.BookingScaleEnum = exports.BookingTypeEnum = exports.AllocationStateEnum = void 0;
var AllocationStateEnum;
(function (AllocationStateEnum) {
  AllocationStateEnum["PERCENTAGE"] = "PERCENTAGE";
  AllocationStateEnum["HOURS_DAY"] = "HOURS_DAY";
  AllocationStateEnum["TOTAL_HOURS"] = "TOTAL_HOURS";
})(AllocationStateEnum || (exports.AllocationStateEnum = AllocationStateEnum = {}));
var BookingTypeEnum;
(function (BookingTypeEnum) {
  BookingTypeEnum["APPROVED"] = "APPROVED";
  BookingTypeEnum["REJECTED"] = "REJECTED";
  BookingTypeEnum["WAITING_FOR_APPROVAL"] = "WAITING_FOR_APPROVAL";
  BookingTypeEnum["SCHEDULED"] = "SCHEDULED";
})(BookingTypeEnum || (exports.BookingTypeEnum = BookingTypeEnum = {}));
var BookingScaleEnum;
(function (BookingScaleEnum) {
  BookingScaleEnum["SCALE_HOUR"] = "SCALE_HOUR";
  BookingScaleEnum["SCALE_WEEK"] = "SCALE_WEEK";
  BookingScaleEnum["SCALE_MONTH"] = "SCALE_MONTH";
  BookingScaleEnum["SCALE_DAY"] = "SCALE_DAY";
})(BookingScaleEnum || (exports.BookingScaleEnum = BookingScaleEnum = {}));
var BookingRepeatEnum;
(function (BookingRepeatEnum) {
  BookingRepeatEnum["NONE"] = "NONE";
  BookingRepeatEnum["DAILY"] = "DAILY";
  BookingRepeatEnum["WEEKLY"] = "WEEKLY";
  BookingRepeatEnum["BI_WEEKLY"] = "BI_WEEKLY";
  BookingRepeatEnum["MONTHLY"] = "MONTHLY";
  BookingRepeatEnum["YEARLY"] = "YEARLY";
  BookingRepeatEnum["CUSTOM"] = "CUSTOM";
})(BookingRepeatEnum || (exports.BookingRepeatEnum = BookingRepeatEnum = {}));
var BookingRepeatIntervalEnum;
(function (BookingRepeatIntervalEnum) {
  BookingRepeatIntervalEnum["DAY"] = "DAY";
  BookingRepeatIntervalEnum["WEEK"] = "WEEK";
  BookingRepeatIntervalEnum["MONTH"] = "MONTH";
  BookingRepeatIntervalEnum["YEAR"] = "YEAR";
})(BookingRepeatIntervalEnum || (exports.BookingRepeatIntervalEnum = BookingRepeatIntervalEnum = {}));
var RepeatEndsOnEnum;
(function (RepeatEndsOnEnum) {
  RepeatEndsOnEnum["DATE"] = "DATE";
  RepeatEndsOnEnum["AFTERTIMES"] = "AFTERTIMES";
  RepeatEndsOnEnum["NEVER"] = "NEVER";
})(RepeatEndsOnEnum || (exports.RepeatEndsOnEnum = RepeatEndsOnEnum = {}));
var RepeatMonthlyOnEnum;
(function (RepeatMonthlyOnEnum) {
  RepeatMonthlyOnEnum["DATES"] = "DATES";
  RepeatMonthlyOnEnum["CUSTOM"] = "CUSTOM";
})(RepeatMonthlyOnEnum || (exports.RepeatMonthlyOnEnum = RepeatMonthlyOnEnum = {}));